<template>
  <div class="register-screen">
    <div class="header part">
      <div class="title">Submit your score</div>
      <div class="subtitle">
        Enter your
        <span class="highlighted-text">name</span> and
        <span class="highlighted-text">email</span>!
      </div>
    </div>
    <form @submit.prevent="handleRegister">
      <div class="part form">
        <div class="input-group">
          <i class="fas fa-user"></i
          ><input
            v-model="name"
            type="text"
            name="name"
            size="20"
            placeholder="Your name"
          />
        </div>
        <div class="input-group">
          <i class="fas fa-envelope"></i
          ><input
            v-model="email"
            type="email"
            name="email"
            size="20"
            placeholder="Your email"
          />
        </div>
      </div>
      <div class="part play-now">
        <template v-if="requestSent">
          <p class="loading">Submitting score... :)</p>
        </template>
        <template v-else>
          <button @click="handleRegister" type="submit" class="img-a-button">
            <img src="@/assets/btn-submit.png" alt="Submit score" />
          </button>
        </template>
      </div>
      <div v-if="!requestSent" class="part play-again">
        <a @click="handlePlayAgain">Play Again!</a>
      </div>
    </form>
  </div>
</template>

<script>
import {
  requiresAuth,
  signInOrRegister,
  currentUser
} from "@/services/auth.service.js";
import { functions } from "@/main.js";
import { validateEmail } from "@/utils";

export default {
  props: ["referralId"],
  data() {
    return {
      email: "",
      titleizedName: "",
      requestSent: false
    };
  },
  computed: {
    isValid() {
      return this.name !== "" && validateEmail(this.email);
    },
    name: {
      set(val) {
        const capitalize = function(str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        };
        this.titleizedName = val
          .split(" ")
          .map(s => capitalize(s))
          .join(" ");
      },
      get() {
        return this.titleizedName;
      }
    }
  },
  methods: {
    handlePlayAgain() {
      this.$emit("play-again");
    },
    async handleRegister() {
      if (!this.isValid) return;
      this.requestSent = true;
      await signInOrRegister(this.email, this.name, this.referralId);
      if (!requiresAuth()) this.$emit("auth-status-changed");
    }
  }
};
</script>

<style lang="scss">
.register-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 20px 10px;
  .part {
    margin: 15px 0;
  }
  .header {
    .title {
      font-size: 1.5rem;
    }
  }

  .social-buttons a {
    box-shadow: none;
    margin: 0 15px;
    &:hover {
      transform: translateY(-5px);
    }
  }

  p {
    font-size: 0.625rem;
  }

  .form {
    margin: 50px 0;
    display: flex;
    justify-content: space-between;
    .input-group {
      margin: 0 10px;
      input {
        color: inherit;
        font-size: 0.725rem;
        font-family: inherit;
        margin-left: 8px;
        background: none;
        border: none;
        border-bottom: 3px solid $accent-color;
        &::placeholder {
          color: currentColor;
        }
        &:focus {
          outline: none;
        }
      }
    }
  }

  .play-again {
    font-size: 0.8rem;
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .part.form {
    flex-direction: column;
    .input-group {
      margin: 10px 0;
    }
  }
}
</style>
